import { FONT_PRIMARY, FONT_SECONDARY } from "@/theme/typography";
import { List, ListItem } from "@mui/material";
import { Link } from "react-scroll";

const SectionLinks = () => {
  const sectionNames = [
    "Introduction",
    "Software and tools",
    "Other resources",
    "Conclusion",
  ];

  return (
    <List disablePadding sx={{ mb: { xs: 3, md: 8 } }}>
      {sectionNames.map((item, index) => (
        <ListItem
          key={index}
          disablePadding
          sx={{
            fontSize: { xs: "1rem", md: "1.125rem" },
            fontWeight: 500,
            fontFamily: FONT_SECONDARY,

            ":not(:last-of-type)": {
              pb: { xs: 1.5, md: 2 },
            },
            ":first-of-type": {
              color: "text.accent",
              fontWeight: 700,
              fontFamily: FONT_PRIMARY,
            },
            "& .active": {
              color: "text.accent",
              fontWeight: 700,
              fontFamily: FONT_PRIMARY,
            },
          }}
        >
          <Link
            to={item}
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            style={{ cursor: "pointer" }}
          >
            {item}
          </Link>
        </ListItem>
      ))}
    </List>
  );
};

export default SectionLinks;
